let checkProjectConfig = {
    appThat: null,
    setAppThat: function(appThat){
        this.appThat = appThat;
        return this;
    }
}

checkProjectConfig.status = function(){
    //存在配置(单一原则)
    if(checkProjectConfig.appThat.$projectConfig){
      return true;
    }else{
      return false;
    }
}

checkProjectConfig.checkValue = function( key , defaultValue ){
   let newCheckValue = defaultValue;
   if(checkProjectConfig.status()){
      if(checkProjectConfig.appThat.$projectConfig[key]){
        newCheckValue = checkProjectConfig.appThat.$projectConfig[key]
      }else{
        if(typeof checkProjectConfig.appThat.$projectConfig[key] === "boolean"){
          newCheckValue = checkProjectConfig.appThat.$projectConfig[key];
        }
      }
   }
   return newCheckValue 
}

export default checkProjectConfig;